export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/VideoEntryPoint.0f1e5f52.svg","height":68,"width":104,"blurWidth":0,"blurHeight":0};